import { baseAdminURL } from '../../routes';
import { IS_PROD } from '../config';
import isEmail from 'validator/lib/isEmail';

export const isPortalApplication = () => {
  return !window.location.pathname.includes(baseAdminURL);
};

export const handleKeyPressPhoneNumber = (event: any) => {
  const pattern = /^[+0-9]*$/;
  const inputChar = String.fromCharCode(event.charCode);

  if (!pattern.test(inputChar)) {
    event.preventDefault();
  }
};

export const isGTM =
  IS_PROD &&
  (window.location.pathname.includes('/go/') ||
    (window.location.pathname.includes('/portal') &&
      !window.location.pathname.includes('_portal')));

export const isValidEmail = (email: string) => {
  return isEmail(email);
};
